// Port of api/fuel/app/classes/insights/plays/overview.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'overview',
    priority: 10,
    insight: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''

        var rangeDays = Math.ceil((range.end - range.start) / Constants.TIME_DAY)

        var overview = {
            plays: 0,
            games: 0,
            first: 0,
            once: 0,
            played5: 0,
            played10: 0,
            played25: 0,
            playedunowned: 0,
            avgRating: 0,
            avgDay: 0,
            avgWeek: 0,
            avgMonth: 0,
            avgYear: 0
        }

        if (owner.get_count_plays()) {

            var playedIndex = Util.queryFast(
                'SELECT SUM(p.play_count) AS p, COUNT(DISTINCT p.game_id) AS g' +
                ' FROM play p' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date <= ' + (range.end - 1) +
                sqlCount
            )

            if (playedIndex[0] && playedIndex[0].g) {

                playedIndex = playedIndex[0]

                overview.plays = parseInt(playedIndex.p, 10)
                overview.games = parseInt(playedIndex.g, 10)

                // Average rating of played games
                var ratingRows = Util.queryFast(
                    'SELECT r.rating_value AS r' +
                    ' FROM play p, rating r' +
                    ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                    ' AND p.game_id = r.game_id' +
                    ' AND p.user_id = r.user_id' +
                    ' AND p.play_date >= ' + range.start +
                    ' AND p.play_date <= ' + (range.end - 1) +
                    sqlCount
                )

                if (ratingRows.length) {
                    var ratingSum = 0
                    for (var ri = 0; ri < ratingRows.length; ri++) {
                        ratingSum += parseFloat(ratingRows[ri].r)
                    }
                    overview.avgRating = Math.round((ratingSum / ratingRows.length) * 10) / 10
                }

                // First-time plays (games whose earliest play is within the range)
                var firstPlays = Util.queryFast(
                    'SELECT COUNT(DISTINCT p.game_id) AS g' +
                    ' FROM play p' +
                    ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                    sqlCount +
                    ' GROUP BY p.game_id' +
                    ' HAVING MIN(p.play_date) >= ' + range.start +
                    ' AND MIN(p.play_date) <= ' + (range.end - 1)
                )

                overview.first = firstPlays.length

                // Per-game play totals for threshold counts
                var gamePlayTotals = Util.queryFast(
                    'SELECT SUM(p.play_count) AS total' +
                    ' FROM play p' +
                    ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                    ' AND p.play_date >= ' + range.start +
                    ' AND p.play_date <= ' + (range.end - 1) +
                    sqlCount +
                    ' GROUP BY p.game_id'
                )

                for (var ti = 0; ti < gamePlayTotals.length; ti++) {
                    var t = parseInt(gamePlayTotals[ti].total, 10)
                    if (t === 1) overview.once++
                    if (t >= 5) overview.played5++
                    if (t >= 10) overview.played10++
                    if (t >= 25) overview.played25++
                }

                // Percentage of played games that are unowned
                var ownedPlayed = Util.queryFast(
                    'SELECT COUNT(DISTINCT p.game_id) AS s' +
                    ' FROM play p, collection c' +
                    ' WHERE c.user_id IN(' + Util.in(userIndex) + ')' +
                    ' AND p.user_id IN(' + Util.in(userIndex) + ')' +
                    ' AND c.collection_own = 1' +
                    ' AND p.play_date >= ' + range.start +
                    ' AND p.play_date <= ' + (range.end - 1) +
                    ' AND p.game_id = c.game_id' +
                    sqlCount
                )

                if (ownedPlayed.length) {
                    overview.playedunowned = (100 / overview.games) * (overview.games - parseInt(ownedPlayed[0].s, 10))
                }

                overview.avgDay = Math.round((overview.plays / rangeDays) * 10) / 10
                overview.avgWeek = Math.round((overview.plays / Math.ceil(rangeDays / 7)) * 10) / 10
                overview.avgMonth = Math.round((overview.plays / Math.ceil(rangeDays / 30.5)) * 10) / 10
                overview.avgYear = Math.round((overview.plays / Math.ceil(rangeDays / 365)) * 10) / 10

            }

        }

        this._data.overview = overview

        return {
            overview: overview
        }

    }
})
